class FilterStruct {
    entityName;
    fieldName;
    displayName;
    hasOptions;
    options;
    optionLabel;
    optionValue;
    selected;
    value;
    isDate;
    isInt;
    isFloat;
    isNumeric;
    isBool;
    isAlphanumeric;
    isString;
    allowedLength;
    isSelected;
    isBerry;
    isAsync;

    constructor(filter) {
        this.entityName = filter.EntityName || '';
        this.fieldName = filter.FieldName || '';
        this.displayName = filter.DisplayName || '';
        this.hasOptions = filter.hasOptions || false;
        this.options = filter.Options || [];
        this.optionLabel = filter.OptionLabel || 'label';
        this.optionValue = filter.OptionValue || 'Code';
        this.selected = filter.selected || [];
        this.value = filter.value || '';
        this.isDate = filter.isDate || false;
        this.isInt = filter.isInt || false;
        this.isFloat = filter.isFloat || false;
        this.isNumeric = filter.isNumeric || false;
        this.isBool = filter.isBool || false;
        this.isAlphanumeric = filter.isAlphanumeric || false;
        this.isString = filter.isString || false;
        this.allowedLength = filter.allowedLength || null;
        this.isSelected = false;
        this.isBerry = filter.IsBerry || false;
        this.isAsync = filter.IsAsync || false;
    }
}

const createFilter = (field) => {
    switch (field.Datatype.toLowerCase()) {
        case 'int':
            field.isInt = true;
            break;
        case 'float':
            field.isFloat = true;
            break;
        case 'string':
            field.isString = true;
            break;
        case 'bool':
            field.isBool = true;
            break;
        case 'date':
            field.isDate = true;
            break;
        case 'alphanumeric':
            field.isAlphanumeric = true;
            break;
        case 'lookup':
        case 'attribute':
        case 'entity':
            field.hasOptions = true;
            break;

        default:
            break;
    }

    if (field.IsAsync) {
        field.hasOptions = false;
    }

    return new FilterStruct(field);
};

export default createFilter;
